<div class="flex-row-desktop flex-col-mobile items-start justify-between mb-4">
  <div class="flex flex-col">
    <div class="flex-row flex-gap-4 items-center justify-start">
      <mat-icon class="text-color-light-blue">{{icon}}</mat-icon>
      @if (title) {
        <span class="font-size-14 font-weight-500 text-color-black">{{title}}</span>
      }
      @if (tripBookingPackage.target_info && tripBookingPackage.target_info.family) {
        <span class="font-size-12 font-weight-200">{{'(Biglietto Famiglia)' | translate}}</span>
      }
      <ng-content select="[title]"></ng-content>
    </div>
    <ng-content select="[sub-title-1]"></ng-content>
    @if (tripBookingPackage.properties?.pratica_code?.value) {
      <span class='font-size-14 secondary-text'>{{'Codice Pratica' | translate}}: {{tripBookingPackage.properties.pratica_code.value}}</span>
    }
    @if (bookingService.statusText[tripBookingPackage.booking_status]) {
      @if (tripBookingStatus == 'mix') {
        <span [class]="bookingService.statusTextColor[tripBookingPackage.booking_status] || 'orange-fg'">{{bookingService.statusText[tripBookingPackage.booking_status]}}</span>
      }
    }
    <ng-content select="[sub-title-2]"></ng-content>
  </div>
  <div class="flex-row flex-gap-4 items-center justify-end">
    @if (!hidePrice) {
      <strong class="font-size-12 font-weight-500 text-color-black" [matTooltip]='"lordo" | translate'>{{tripBookingPackage.total_amount | currency:'EUR' }}</strong>
    }
    @if (!hidePrice && tripBookingPackage.total_amount_net != tripBookingPackage.total_amount) {
      <strong class="font-size-12 font-weight-500 text-color-black" [matTooltip]='"netto" | translate'>/ {{tripBookingPackage.total_amount_net | currency:'EUR' }}</strong>
    }
    @if (showInfo) {
      <a mat-icon-button color='accent' [matTooltip]='"Apri dettagli" | translate' (click)="infoClick.emit();$event.stopPropagation();">
        <mat-icon>info</mat-icon>
      </a>
    }
    @if (showConfirm) {
      <button [disabled]="bookingService.loading.value" mat-icon-button (click)='confirmClick.emit();$event.stopPropagation();' [matTooltip]='"Conferma" | translate'>
        <mat-icon color='primary'>done</mat-icon>
      </button>
    }
    @if (showEdit) {
      <button mat-icon-button color='accent' [disabled]="bookingService.loading.value" [matTooltip]='"Modifica" | translate' (click)='editClick.emit();$event.stopPropagation();'>
        <mat-icon>edit</mat-icon>
      </button>
    }

    @if (canDelete) {
      <button class="delete-trip-btn" mat-icon-button [disabled]="bookingService.loading.value" (click)='deleteClick.emit();$event.stopPropagation();' matTooltip="Elimina">
        <mat-icon color='warn'>delete</mat-icon>
      </button>
    }
    @if (canCancel) {
      <button class="delete-trip-btn" mat-icon-button [disabled]="bookingService.loading.value" (click)='deleteClick.emit();$event.stopPropagation();' matTooltip="Annulla">
        <mat-icon color='warn'>delete</mat-icon>
      </button>
    }
  </div>
</div>
